module.exports = __webpack_public_path__ + "media/images/shelf_preview_portrait-c4fb78b26fb6360ab04e7fc0e0b5ef09.png";